import type { SignalingSpec } from "@codeshare/config";
import {
  createBroadcastChannelBus,
  createMemoryBus,
  type MemoryBus,
  MemorySignaling,
  NostrSignaling,
  type SignalingAdapter,
} from "@codeshare/signaling";

const buses = new Map<string, MemoryBus>();
const inProcessBus = createMemoryBus();

/** Builds signaling adapters from config. Memory signaling is for tests only. */
export function createAdapters(specs: readonly SignalingSpec[]): SignalingAdapter[] {
  return specs.map(createAdapter);
}

function createAdapter(spec: SignalingSpec): SignalingAdapter {
  if (spec.type === "nostr") return new NostrSignaling({ relays: spec.relays });
  if (!spec.channel) return new MemorySignaling(inProcessBus);
  let bus = buses.get(spec.channel);
  if (!bus) {
    bus = createBroadcastChannelBus(spec.channel);
    buses.set(spec.channel, bus);
  }
  return new MemorySignaling(bus);
}
